export default class TourOperator {
  code = ''
  consumerCode = ''
  market = ''
  name = ''
}
